import * as vp from 'vopay';

import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import type { ChangePasswordHandlers } from '../types';
import buildChangePasswordRows from './buildChangePasswordRows.helper';
import { usePartnerData } from '@/providers/PartnerData.provider';

const { Box, Button, SubTitle, Table, TextField, Icon, BackButton } = vp;

type ChangePasswordProps = {
  handlers: ChangePasswordHandlers;
  defaultValues: vp.AccountUsersChangePasswordRequest;
};

type FC = FunctionComponent<ChangePasswordProps>;
const ChangePassword: FC = (props: ChangePasswordProps) => {
  const { handlers, defaultValues } = props;
  const permissionRows = buildChangePasswordRows();
  const {
    response: { isRoleViewOnly },
  } = usePartnerData();
  return (
    <Formik initialValues={defaultValues} onSubmit={handlers.onChangePassword}>
      {({ handleChange, handleBlur, handleSubmit }) => {
        const changePasswordTable: vp.TableProps = {
          name: 'add-user-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: permissionRows.map(({ label, id }) => ({
            Field: label,
            Input: (
              <TextField
                key={id}
                name={id}
                variant="standard"
                elementLeft={<Icon icon="lock" size="md" />}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box mb="lg" jc="fs" ai="center" gap="common">
              <BackButton variant="arrow" backButtonEnabled />
              <SubTitle subTitle="Change Password" />
            </Box>
            <Table {...changePasswordTable} />
            <Box mt="md" jc="fe">
              <Button id="ChangePasswordForm-submit" type="submit" label="Save" isDisabled={isRoleViewOnly} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default ChangePassword;
